export const ENVIRONMENTS = {
  local: {
    name: 'LOCAL',
    //baseUrl: 'http://cfxproapi.dev.speakfeel.com/canfaxservice.svc/',
    //baseUrl: 'http://localhost:4356/CanFaxService.svc/v3/',
    baseUrl: 'https://cfxproapi.canfax.ca/canfaxservice.svc/v3/',
  },
  development: {
    name: 'DEVELOPMENT',
    //baseUrl: 'https://cfxproapi.dev.canfax.ca/canfaxservice.svc/v3/',
    baseUrl: 'https://cfxproapi.canfax.ca/canfaxservice.svc/v3/',
  },
  production: {
    name: 'PRODUCTION',
    baseUrl: 'https://cfxproapi.canfax.ca/canfaxservice.svc/v3/',
  },
}

export const BASE_URL = (function() {
  if (process.env.NODE_ENV === 'local') {
    console.log('Using Local Environment')
    return ENVIRONMENTS.local.baseUrl
  } else if (process.env.NODE_ENV === 'development') {
    console.log('Using Development Environment')
    return ENVIRONMENTS.development.baseUrl
  } else {
    console.log('Using Production Environment')
    return ENVIRONMENTS.production.baseUrl
  }
})()

export const REGEX = {
  float: '([0-9]+)?(.[0-9]{0,2})?',
  date: '([0-9]{0,4})(-[0-9]{0,2})?{0,2}',
}

export const API_JSON_KEY = {
  dtn: 'DTN',
  dtnLiveCattle: 'LE',
  dtnFeeder: 'GF',
  dtnCDN: 'CD',
  dtnCorn: 'C',
  cpip: 'CPIP',
  cpipFed: 'FED',
  cpipAlbertaFeeder: 'FEEDER',
  cpipAlbertaCalf: 'CALF',
  cpipSaskmanCalf: 'SASKMAN CALF',
  cpipSaskmanFeeder: 'SASKMAN FEEDER',
  settlementIndices: 'settlement_indices',
  basis: 'basis',
}

// These Keys must match the URL Params
export const LOCAL_KEY = {
  dtnLiveCattle: 'livecattle',
  dtnFeeder: 'feeder',
  dtnCDN: 'cdn',
  dtnCorn: 'corn',
  cpipWcpipFed: 'wcpipfed',
  cpipAlbertaFeeder: 'albertafeeder',
  cpipAlbertaCalf: 'albertacalf',
  cpipSaskmanCalf: 'saskmancalf',
  cpipSaskmanFeeder: 'saskmanfeeder',
  settlementIndices: 'settlementindices',
}

export const feedCodeToTitle = (key) => {
  switch (key) {
    case LOCAL_KEY.dtnLiveCattle: {
      return 'Live Cattle'
    }
    case LOCAL_KEY.dtnFeeder: {
      return 'Feeder'
    }
    case LOCAL_KEY.dtnCDN: {
      return 'CDN'
    }
    case LOCAL_KEY.dtnCorn: {
      return 'Corn'
    }
    case LOCAL_KEY.cpipWcpipFed: {
      return 'WCPIP Fed'
    }
    case LOCAL_KEY.cpipAlbertaFeeder: {
      return 'Alberta Feeder'
    }
    case LOCAL_KEY.cpipAlbertaCalf: {
      return 'Alberta Calf'
    }
    case LOCAL_KEY.cpipSaskmanCalf: {
      return 'Saskman Calf'
    }
    case LOCAL_KEY.cpipSaskmanFeeder: {
      return 'Saskman Feeder'
    }
    case LOCAL_KEY.settlementIndices: {
      return 'Settlement Indices'
    }
    default: {
      return 'Unknown'
    }
  }
}

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const MONTH_NAMES_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const MONTH_CHART_KEY = {
  Jan: 'F',
  Feb: 'G',
  Mar: 'H',
  Apr: 'J',
  May: 'K',
  Jun: 'M',
  Jul: 'N',
  Aug: 'Q',
  Sep: 'U',
  Oct: 'V',
  Nov: 'X',
  Dec: 'Z',
}

export const PAGES = {
  futuresMarket: {
    key: 1,
    path: '/futures',
    title: 'Futures',
    icon: 'fa fa-chart-line',
  },
  priceInsurance: {
    key: 2,
    path: '/price/insurance',
    title: 'Insurance',
    icon: 'fa fa-hand-holding-usd',
    subItems: [
      {
        key: 2.1,
        path: '/price/insurance/wcpipfed',
        title: 'WCPIP Fed',
      },
      {
        key: 2.2,
        path: '/price/insurance/albertafeeder',
        title: 'Alberta Feeder',
      },
      {
        key: 2.3,
        path: '/price/insurance/albertacalf',
        title: 'Alberta Calf',
      },
      {
        key: 2.4,
        path: '/price/insurance/saskmancalf',
        title: 'SaskMan Calf',
      },
      {
        key: 2.5,
        path: '/price/insurance/saskmanfeeder',
        title: 'SaskMan Feeder',
      },
      {
        key: 2.6,
        path: '/price/insurance/settlementindices',
        title: 'Settlement Indices',
      },
    ],
  },
  breakevenCalculator: {
    key: 3,
    path: '/breakeven',
    title: 'Breakeven',
    icon: 'fa fa-calculator',
    subItems: [
      {
        key: 3.1,
        path: '/breakeven/backgrounder',
        title: 'Saved Backgrounders',
      },
      {
        key: 3.2,
        path: '/breakeven/backgrounder/calculator',
        title: 'Add Backgrounder',
      },
      {
        key: 3.3,
        path: '/breakeven/finishing',
        title: 'Saved Finishings',
      },
      {
        key: 3.4,
        path: '/breakeven/finishing/calculator',
        title: 'Add Finishing',
      },
    ],
  },
  priceProjections: {
    key: 4,
    path: '/price/projections',
    title: 'Projections',
    icon: 'fa fa-calculator',
    subItems: [
      {
        key: 4.1,
        path: '/price/projections',
        title: 'Saved Price Projections',
      },
      {
        key: 4.2,
        path: '/price/projections/calculator',
        title: 'Add Price Projection',
      },
    ],
  },
  contactUs: {
    key: 5,
    path: '/contact',
    title: 'Contact Us/Report Prices',
    icon: 'fa fa-envelope',
  },
  resetDefaults: {
    key: 6,
    path: '/resetDefaults',
    title: 'Reset Defaults',
    icon: 'fa fa-sync-alt',
  },
}

export const HEIFER_INDEX = 0
export const STEER_INDEX = 1

export const BARLEY_COST_FROM_TONNE_TO_BUSHEL = 45.93
export const BARLEY_COST_PER_BUSHEL_TO_SILAGE = 12.5
export const LBS_TO_TONNES = 2204.6
export const SECONDS_PER_DAY = 24 * 60 * 60
export const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000
export const DAYS_IN_YEAR = 365



// WEBPACK FOOTER //
// ./src/constants.js